module.exports = __webpack_public_path__ + "img/mci_logo_square_colored.7eb4bff2.jpeg";